import { render, staticRenderFns } from "./SaveImageButton.vue?vue&type=template&id=8c131d8e"
import script from "./SaveImageButton.vue?vue&type=script&lang=js"
export * from "./SaveImageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports